"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PlatformLoader", {
  enumerable: true,
  get: function () {
    return _PlatformLoader.default;
  }
});
Object.defineProperty(exports, "PlatformLoaderStyled", {
  enumerable: true,
  get: function () {
    return _PlatformLoader2.Container;
  }
});

var _PlatformLoader = _interopRequireDefault(require("./PlatformLoader"));

var _PlatformLoader2 = require("./PlatformLoader.styles");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvUGxhdGZvcm1Mb2FkZXIvaW5kZXgudHMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHsgZGVmYXVsdCBhcyBQbGF0Zm9ybUxvYWRlciB9IGZyb20gJy4vUGxhdGZvcm1Mb2FkZXInXG5leHBvcnQgeyBDb250YWluZXIgYXMgUGxhdGZvcm1Mb2FkZXJTdHlsZWQgfSBmcm9tICcuL1BsYXRmb3JtTG9hZGVyLnN0eWxlcydcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7QUFDQSJ9